import { IonButton, IonIcon, IonText } from "@ionic/react";
import { notificationsOutline } from "ionicons/icons";
import { useEffect } from "react";

import { usePilotoStatus } from "src/hooks/usePilotoStatus";
import { usePushNotifications } from "src/hooks/usePushNotifications";

// Tarjeta destacada en Home para invitar al operario a activar las
// notificaciones. Se muestra unicamente si:
//   - El usuario esta dentro del piloto (fiscal piloto o sus operarios), Y
//   - El dispositivo soporta push, Y
//   - Las notificaciones no estan activas todavia en este dispositivo.
//
// No es descartable: la idea es que la tarjeta quede visible hasta que el
// operario active. El boton "Activar ahora" dispara la activacion ahi mismo
// reutilizando el flujo del perfil (mismo hook usePushNotifications).
const BannerActivarNotificaciones: React.FC = () => {
  const { enPiloto, cargado: pilotoCargado } = usePilotoStatus();
  const {
    pushSupported,
    pushPermission,
    pushActive,
    pushLoading,
    pushError,
    refrescarEstadoPush,
    activarNotificaciones,
  } = usePushNotifications();

  // Cargar estado actual de push cuando confirmamos que el usuario esta en piloto
  useEffect(() => {
    if (enPiloto) {
      refrescarEstadoPush();
    }
  }, [enPiloto, refrescarEstadoPush]);

  if (!pilotoCargado) return null;
  if (!enPiloto) return null;
  if (!pushSupported) return null;
  if (pushActive) return null;

  const permisoDenegado = pushPermission === "denied";

  return (
    <div className="container mt-1">
      <div
        style={{
          background: "#FFF3CD",
          border: "1px solid #FFE69C",
          borderRadius: 12,
          padding: 16,
          color: "#664D03",
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
          <IonIcon
            icon={notificationsOutline}
            style={{ fontSize: 28, flexShrink: 0, marginTop: 2 }}
          />
          <div style={{ flex: 1 }}>
            <IonText>
              <p style={{ margin: 0, fontWeight: 700, fontSize: "1rem" }}>
                Activa tus notificaciones
              </p>
              <p style={{ margin: "6px 0 0", fontSize: "0.9rem", lineHeight: 1.4 }}>
                Te avisamos cuando no marcaste para que puedas informar tu situacion.
              </p>
            </IonText>

            {permisoDenegado && (
              <div
                style={{
                  marginTop: 12,
                  background: "#fff",
                  border: "1px solid #FFD6A5",
                  borderRadius: 8,
                  padding: "10px 12px",
                  fontSize: "0.85rem",
                  color: "#664D03",
                }}
              >
                <strong>Permiso denegado en el dispositivo:</strong>
                <ol style={{ margin: "6px 0 0", paddingLeft: 18 }}>
                  <li>Anda a Ajustes / Apps / tu navegador</li>
                  <li>Notificaciones / Permitir</li>
                  <li>Volve a la app y toca Activar ahora</li>
                </ol>
              </div>
            )}

            {pushError && !permisoDenegado && (
              <p
                style={{
                  margin: "8px 0 0",
                  color: "#A94442",
                  fontSize: "0.85rem",
                }}
              >
                {pushError}
              </p>
            )}

            <div style={{ marginTop: 12 }}>
              <IonButton
                expand="block"
                onClick={activarNotificaciones}
                disabled={pushLoading || permisoDenegado}
              >
                {pushLoading ? "Activando..." : "Activar ahora"}
              </IonButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerActivarNotificaciones;
